import { NgModule } from '@angular/core';
import {
	ArrowDownUp,
	ArrowLeft,
	ArrowLeftRight,
	ArrowRight,
	Bell,
	Building2,
	Calendar,
	Check,
	CheckSquare,
	ChevronDown,
	ChevronFirst,
	ChevronLast,
	ChevronUp,
	Clock,
	CloudUpload,
	Copy,
	CreditCard,
	Download,
	Edit,
	EllipsisVertical,
	Eye,
	EyeOff,
	File,
	Filter,
	Gift,
	House,
	Image,
	Info,
	LayoutDashboard,
	LayoutGrid,
	LifeBuoy,
	ListCollapse,
	Loader,
	Lock,
	LockKeyhole,
	LogOut,
	LucideAngularModule,
	Mail,
	MapPin,
	Menu,
	MessageSquareText,
	Mic,
	Moon,
	PanelLeftClose,
	PanelRightClose,
	Paperclip,
	Pencil,
	PencilRuler,
	Phone,
	PhoneCall,
	Plus,
	RefreshCw,
	Scale,
	ScrollText,
	Search,
	Send,
	Settings,
	Settings2,
	Siren,
	Square,
	SquareDashedMousePointer,
	Sun,
	Tag,
	Trash,
	Trash2,
	Undo2,
	User,
	UserCheck,
	UserCog,
	UserPlus,
	Users,
	UserX,
	Volume2,
	Wallet,
	Webcam,
	X,
	XCircle,
} from 'lucide-angular';

@NgModule({
	imports: [
		LucideAngularModule.pick({
			CloudUpload,
			Search,
			LockKeyhole,
			EyeOff,
			Bell,
			Mail,
			Calendar,
			Menu,
			UserCog,
			LayoutDashboard,
			ArrowLeftRight,
			Users,
			Wallet,
			ScrollText,
			PanelRightClose,
			Siren,
			Settings,
			LifeBuoy,
			LogOut,
			ChevronFirst,
			ChevronLast,
			ChevronDown,
			ChevronUp,
			X,
			ArrowLeft,
			Sun,
			SquareDashedMousePointer,
			Moon,
			PanelLeftClose,
			Filter,
			Gift,
			Plus,
			EllipsisVertical,
			Pencil,
			Trash2,
			ArrowDownUp,
			Phone,
			MapPin,
			Webcam,
			PhoneCall,
			ArrowRight,
			Download,
			Undo2,
			File,
			Scale,
			MessageSquareText,
			House,
			Clock,
			User,
			LayoutGrid,
			ListCollapse,
			Paperclip,
			Check,
			Building2,
			Image,
			Mic,
			PencilRuler,
			Eye,
			CheckSquare,
			UserPlus,
			UserCheck,
			UserX,
			Edit,
			Trash,
			Tag,
			CreditCard,
			Settings2,
			Info,
			RefreshCw,
			Volume2,
			Square,
			Send,
			Loader,
			Lock,
			Copy,
			XCircle,
		}),
	],
	exports: [LucideAngularModule],
})
export class LucideModule {}
